import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface LogoutConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const LogoutConfirmationDialog: React.FC<
  LogoutConfirmationDialogProps
> = ({ open, onOpenChange, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md w-[calc(100%-32px)] rounded-[16px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-center mt-2">
            {t("profile.logout_confirm.title", "Logout")}
          </DialogTitle>
          <DialogDescription className="text-center text-sm mt-3 pt-2 text-[#5B616D]">
            {t(
              "profile.logout_confirm.message",
              "Are you sure you want to log out of your account?",
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-row sm:justify-center gap-3 mt-6 pt-2">
          <DialogClose asChild>
            <Button
              type="button"
              variant="outline"
              className="flex-1 rounded-[12px] h-12 border-[#101828]/[0.06] shadow-none hover:bg-gray-50 text-[#101828] font-semibold"
            >
              {t("common.cancel", "Cancel")}
            </Button>
          </DialogClose>
          <Button
            type="button"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className="flex-1 rounded-[12px] h-12 bg-red-500 hover:bg-red-600 shadow-[0px_4px_12px_rgba(239,68,68,0.2)] font-semibold text-white"
          >
            {t("profile.logout_confirm.title", "Logout")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
